module.exports = __webpack_public_path__ + "img/suc.18dfc855.png";